import { createContext } from "react";

/** Build-only rendering must emit the complete anonymous public document. */
export const PublicPrerenderContext = createContext(false);
